export interface GreetProps {
  status: boolean
  stopAction: boolean
}

export const GREETINGS_SHOW = 'GREETINGS_SHOW'
export const GREETINGS_CLOSE = 'GREETINGS_CLOSE'

interface Show {
  type: typeof GREETINGS_SHOW
  payload: boolean
}

interface Close {
  type: typeof GREETINGS_CLOSE
  payload: boolean
}

export type GREET = Show | Close
